import React from "react";
import { Select, MenuItem, InputLabel } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import { MyBoxContainer, MyFormControl, MyInputMiniLabel } from "../../../utils/theme";

interface ILogPerPageProps {
  handleLogPerPageChange: (event: SelectChangeEvent<number>) => void;
  logPerPage: number;
}
export function LogPerPage(logPerPageProps: ILogPerPageProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <MyBoxContainer display="flex" alignItems="center">
      <MyFormControl variant="standard">
        <MyInputMiniLabel data-cy="log-per-page-label" htmlFor="logPerPage-select">
          {t("log per page")}
        </MyInputMiniLabel>
        <Select
          onChange={logPerPageProps.handleLogPerPageChange}
          name="logPerPage"
          value={logPerPageProps.logPerPage}
          required
          inputProps={{
            name: "logPerPage",
            id: "logPerPage-select"
          }}>
          <MenuItem value={25} selected>
            25
          </MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
          <MenuItem value={200}>200</MenuItem>
        </Select>
      </MyFormControl>
    </MyBoxContainer>
  );
}
